<template>
  <div id="modal_popup_daily" class="modal-popup">
    <div class="modal-popup-content">
      <a @click="closeDailyPopup()" class="close-button">
        <img src="@/assets/images/cms-mkt/close-button.svg" />
      </a>
      <!-- <div class="d-inline-block container-right"> -->
      <div class="offer-details-wrapper">
        <div v-if="newGame == null">
          <img class="w-80" src="@/assets/images/cms-mkt/loading.gif" />
        </div>
        <div v-else class="addRewardLayout border-box flex-wrap flex-xl-nowrap justify-content-center">
          <div class="container-fluid d-flex flex-column align-items-center">
            <small class="text-break">{{ $t("cmsLang.dailyLabel") }}</small>
            <br />
            <div class="row d-flex flex-column align-items-baseline w-80">
              <small class="text-break">{{ $t("cmsLang.rewardLabel") }}</small>
              <input type="number" v-model="newGame.upCoins" class="formedituser w-100" />
            </div>
            <div class="row d-flex flex-column align-items-baseline w-80">
              <small class="text-break">{{ $t("cmsLang.durationLabel") }}</small>
              <div class=" d-flex flex-row justify-content-between w-80">
                <date-range class="invoices-filter" :noRanges="true" :single="true" :minDateOrder="minDate"
                  :time="newGame.startDate" @close="startDateSelected" />
                <date-range class="invoices-filter" :noRanges="true" :single="true" :minDateOrder="minDate"
                  :time="newGame.endDate" @close="endDateSelected" />
              </div>
              <p v-html="$t('cmsLang.gameDateError')" class="red" v-if="this.dateError"></p>
              <p v-else></p>
            </div>
            <div class="row d-flex flex-column align-items-baseline w-80">
              <div class="row d-flex flex-row align-items-baseline justify-content-between w-80">
                <a @click="submitGame(false)" v-if="newGame.status !== 'A'" class="button-all button-blue">
                  {{ $t('cmsLang.saveLabel') }}

                </a>
                <a @click="submitGame(true)" v-if="newGame.status !== 'A' && newGame.id > 0 && isUserAdmin(user)"
                  class="button-all button-yellow">
                  {{ $t('cmsLang.approveLabel') }}

                </a>
                <a @click="showModalPopup('modal_popup_confirmDaily', true)" v-if="newGame.status === 'A'"
                  class="button-all button-red">
                  {{ $t('cmsLang.deleteLabel') }}
                </a>
              </div>
            </div>
          </div>
        </div>


      </div>
      <!-- </div> -->
    </div>
    <div id="modal_popup_confirmDaily" class="modal-popup">
      <div class="modal-popup-content">
        <a @click="showModalPopup('modal_popup_confirmDaily', false)" class="close-button">
          <img src="@/assets/images/cms-mkt/close-button.svg" />
        </a>
        <br />
        <p>
          {{ $t("cmsLang.confirmDeleteDailyMessage") }}
        </p>
        <div class="buttons">
          <a href="#" class="yesButton" @click="deleteGame()">
            {{ $t("cmsLang.notificationsChooseOptionYes") }}
          </a>
          <a href="#" class="noButton" @click="showModalPopup('modal_popup_confirmDaily', false)">
            {{ $t("cmsLang.notificationsChooseOptionNo") }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
// import validator from "@/plugins/fieldValidation";
import DateRange from "@/components/DateRange.vue";
import httpServiceCustomer from "@/http/http-play.js";
import Cookies from "js-cookie";

export default {
  name: "DailyMissionPopup",

  props: {
    user: Object,
  },
  components: {
    DateRange,
  },
  data() {
    return {
      newGame: null,
      minDate: moment().toDate(),
      dateError: false,
      error: null,
    };
  },
  methods: {
    closeDailyPopup() {
      if (this.daily)
        this.newGame = {
          id: this.daily.mission_id,
          endDate: this.daily.end_date ? [moment(this.daily.end_date, 'DD-MM-YYYY')] : [moment()],
          startDate: this.daily.start_date ? [moment(this.daily.start_date, 'DD-MM-YYYY')] : [moment()],
          upCoins: this.daily.up_coins,
          status: this.daily.status,
          type: this.daily.type
        }
      this.showModalPopup('modal_popup_daily', false);
    },
    submitGame(approve) {
      // validare ??
      // construct game object
      this.showModalPopup("modal_popup_loading_cms", true);

      let submitGame = {
        mission_id: this.newGame.id,
        up_coins: this.newGame.upCoins,
        type: this.newGame.type,
        end_date: moment(this.newGame.endDate[0]).format('DD-MM-YYYY'),
        start_date: moment(this.newGame.startDate[0]).format('DD-MM-YYYY')
      }

      if (approve) {
        this.approveGame(submitGame);
      } else if (this.newGame.id > 0) {
        this.updateGame(submitGame);
      } else {
        this.addNewGame(submitGame);
      }
    },
    approveGame(game) {
      httpServiceCustomer.customerService
        .approveGame(
          game,
          Cookies.get("token")
        )
        .then((response) => {
          if (response.status == 200 || response.status == 204) {
            this.$emit("showinfo", "dailyApprovedSuccess", null);
            this.getDailyMission();

          } else {
            this.error =  error.response.data ;
            this.$emit("showinfo", "", this.error);
          }
          this.showModalPopup("modal_popup_loading_cms", false);

        })
        .catch((error) => {
          if (error.response) {
            this.error =  error.response.data ;
          } else {
            this.error = ["undefined"];
          }
          this.$emit("showinfo", "", this.error);
          this.showModalPopup("modal_popup_loading_cms", false);
          this.showModalPopup("modal_popup_info", true);
        });
    },
    updateGame(game) {
      httpServiceCustomer.customerService
        .updateGame(
          game,
          Cookies.get("token")
        )
        .then((response) => {
          if (response.status == 200 || response.status == 204) {
            this.$emit("showinfo", "dailyModifiedSuccess", null);
            this.getDailyMission();

          } else {
            this.error = { code: response.status };
            this.$emit("showinfo", "", this.error);
          }
          this.showModalPopup("modal_popup_loading_cms", false);
          // this.showModalPopup("modal_popup_info", true);
        })
        .catch((error) => {
          if (error.response) {
            this.error =  error.response.data ;
          } else {
            this.error = ["undefined"];
          }
          // this.showModalPopup("modal_popup_loading_cms", false);
          this.showModalPopup("modal_popup_info", true);
          this.$emit("showinfo", "", this.error);
        });
    },
    addNewGame(game) {
      httpServiceCustomer.customerService
        .addNewGame(
          game,
          Cookies.get("token")
        )
        .then((response) => {
          if (response.status == 200 || response.status == 204) {
            this.$emit("showinfo", "dailyAddSuccess", null);
            this.getDailyMission();

          } else {

            this.error = { code: response.status };
            this.$emit("showinfo", "", this.error);
          }
          this.showModalPopup("modal_popup_loading_cms", false);
          // this.showModalPopup("modal_popup_info", true);
        })
        .catch((error) => {
          if (error.response) {
            this.error =  error.response.data ;
          } else {
            this.error = ["undefined"];
          }
          this.showModalPopup("modal_popup_loading_cms", false);
          this.$emit("showinfo", "", this.error);
          // this.showModalPopup("modal_popup_info", true);
        });
    },
    deleteGame() {
      this.successMessage = "";
      this.error = null;
      this.showModalPopup("modal_popup_confirmDaily", false);
      this.showModalPopup("modal_popup_loading_cms", true);

      httpServiceCustomer.customerService
        .deleteGame(
          this.newGame.id,
          Cookies.get("token")
        )
        .then((response) => {
          if (response.status == 200 || response.status == 204) {
            this.$emit("showinfo", "dailyDeleteSuccess", null);
            this.getDailyMission();

          } else {
            this.error = { code: response.status };
          }
          this.showModalPopup("modal_popup_loading_cms", false);
        })
        .catch((error) => {
          if (error.response) {
            this.error =  error.response.data ;
          } else {
            this.error = ["undefined"];
          }
          this.showModalPopup("modal_popup_loading_cms", false);
          this.$emit("showinfo", "", error);
        });
    },
    startDateSelected(value) {
      this.dateError = false;
      if (this.newGame.endDate[0] < value[0]) {
        this.dateError = true;
      } else {
        this.newGame.startDate = value;
      }
    },
    endDateSelected(value) {
      this.dateError = false;
      if (this.newGame.startDate[0] > value[0]) {
        this.dateError = true;
      } else {
        this.newGame.endDate = value;
      }
    },
    getDailyMission() {
      this.daily = null;
      var offersData = "?type=D";
      offersData += "&status=N,I,A";
      offersData +=
        "&per_page=1" +
        "&page=1" +
        httpServiceCustomer.customerService
          .searchGames(offersData, Cookies.get("token"))
          .then(function (response) {
            return response;
          })
          .catch((error) => {
            this.error =  error.response.data ;
          })
          .then((response) => {
            if (response.status == 200) {
              if (response.data.length > 0) {
                this.getDailyDetails(response.data[0].mission_id);
              } else {
                this.newGame = {
                id: 0,
                upCoins: 0,
                startDate: [moment()],
                endDate: [moment()],
                type: "daily",
              };
              }
            }
          });
    },
    getDailyDetails(gameId) {
      httpServiceCustomer.customerService
        .getGameDetails(gameId, Cookies.get("token"))
        .then(function (response) {
          return response;
        })
        .then((response) => {
          if (response.status == 200) {
            if (response.data) {
              let game = response.data;
              this.daily = game;
              this.newGame = {
                id: game.mission_id,
                endDate: game.end_date ? [moment(game.end_date, 'DD-MM-YYYY')] : [moment()],
                startDate: game.start_date ? [moment(game.start_date, 'DD-MM-YYYY')] : [moment()],
                upCoins: game.up_coins,
                status: game.status,
                type: game.type
              }
            } else {
              this.newGame = {
                id: 0,
                upCoins: 0,
                startDate: [moment()],
                endDate: [moment()],
                type: "daily",
              };
            }
          }
        })
        .catch((error) => {
          console.log(error);
          this.error = { code: error.response.code };
        });
    }
  },
  // watch: {
  //   daily: function () {
  //     console.log(this.daily);
  //     if (this.daily == null) {
  //       this.getDailyMission();
  //     }
  //   }
  // },
   mounted() {
    console.log("monted daily")
    this.getDailyMission();
  },
};
</script>
<style scoped src="@/assets/styles/mkt-cms.css"></style>
<style scoped>
.position {
  position: relative;
  left: 227px;
}


.contact-details-wrapper {
  justify-content: space-evenly;
  color: #2D3736;
}

.close-button {
  right: 30px;
  top: 15px;
}

.offer-details-wrapper {
  border-radius: 48px;
  background: #E5E5E5;
  overflow-y: auto;
  height: calc(100vh - 170px) !important;
}

small {
  font-family: "Krona One";
  font-weight: 400;
  font-size: 18px;
  text-transform: uppercase;
}

.w-80 {
  width: 80%;
}

.ql-toolbar.ql-snow {
  border: 2px solid #fff !important;
  border-radius: 48px !important;
}

.multiselect {
  border: 1px solid #d8d8d8;
  background: #f1f1f1 !important;
  height: 40px !important;
  /* border-radius: 20px; */

}

.multiselect__input {
  font-size: 15px !important;
  /* border-radius: 20px !important; */
}

.multiselect__tags {
  border-radius: 40px !important;
  padding: 8px -30px 0 8px !important;
}
</style>
